<div class="ds-gavel-strip" [class.ds-gavel-strip--bottom]="bottomStrip">
  <span class="ds-gavel-label ds-mono ds-mute">GAVEL</span>

  @if (mode === 'paused') {
    <button class="ds-gavel-btn" (click)="resume()">Resume</button>
  } @else {
    <button class="ds-gavel-btn" (click)="pause()">Pause</button>
    @if (socketService.countdownValue() !== null) {
      <button class="ds-gavel-btn ds-gavel-btn--active" (click)="stopCountdown()">
        Stop <kbd>C</kbd>
      </button>
    } @else {
      <button class="ds-gavel-btn" (click)="startCountdown()">
        Countdown <kbd>C</kbd>
      </button>
    }
    @if (mode === 'nominating' && showNomFor) {
      <button class="ds-gavel-btn" (click)="nomForClick.emit()">Nom for…</button>
    }
    @if (mode === 'bidding') {
      <button class="ds-gavel-btn ds-gavel-btn--primary" (click)="endAuction()">
        Sold <kbd>↵</kbd>
      </button>
      <div class="ds-behalf-wrap">
        <label class="ds-mono ds-mute ds-behalf-label">BID AS</label>
        <select
          class="ds-behalf-select"
          [ngModel]="bidOnBehalfUserId"
          (ngModelChange)="onBehalfChange($event)"
        >
          <option [ngValue]="null">Myself</option>
          @for (team of socketService.draftSettings()?.teams || []; track team.user_id) {
            <option [ngValue]="team.user_id">{{ team.user_name }}</option>
          }
        </select>
        @if (bidOnBehalfUserId !== null) {
          <span class="ds-mono ds-mute ds-behalf-max">max ${{ bidOnBehalfMaxBid }}</span>
        }
      </div>
    }
  }
</div>
